import {gsap} from "gsap";
import {Outsourced} from "../../Outsourced";
import {OutsourcedGameAssets} from "../../OutsourcedGameAssets";
import {OutsourcedSymbol, SymbolArgs} from "./OutsourcedSymbol";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";

export class OutsourcedXWaysSymbol extends OutsourcedSymbol {
    private xwaysSpine: PIXI.spine.Spine;
    public hasRevealed = false;

    constructor(args:SymbolArgs) {
        super(args);
    }

    public xWaysReveal(targetSymbol:string, ways:number):gsap.core.Timeline {
        // state :sob:
        if (this.xwaysSpine == undefined) {
            this.xwaysSpine = new PIXI.spine.Spine(Outsourced.assetLoader.getSpineAsset(OutsourcedGameAssets.XWAYS_SPINE));
            this.addChild(this.xwaysSpine);
        }
        const newSymbol =
            new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(targetSymbol))[0]);
        const newSpinSymbol =
            new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(targetSymbol, "_spin"))[0]);
        this.hasRevealed = true;

        return gsap.timeline()
            .add(() => {
                this.removeChild(this.mainSprite);
                this.removeChild(this.spinSprite);
                this.symbolName = targetSymbol;
                this.mainSprite = newSymbol;
                this.mainSprite.alpha = 0;
                this.mainSprite.anchor.set(0.5, 0.5);

                this.spinSprite = newSpinSymbol;
                this.spinSprite.alpha = 0;
                this.spinSprite.anchor.set(0.5, 0.5);

                this.addChildAt(this.mainSprite, 0);
                this.addChildAt(this.spinSprite, 0);
            })
            .add(SpineGSAPWrapper.createTimeline(this.xwaysSpine, 0, `X_${ways == 1 ? "BL" : ways}_Intro`))
            .add(gsap.to(newSymbol, {alpha: 1, duration: 0.1}), '<0.1')
            .add(() => {
                if (ways == 1) {
                   this.mainSprite.visible = false;
                }
                this.xwaysSpine.state.setAnimation(0, `X_${ways == 1 ? "BL" : ways}_Loop`, true)
            });
    }

    public restore(targetSymbol:string, ways:number){
        if (targetSymbol == undefined)
            return;
        this.xWaysReveal(targetSymbol, ways).progress(1);
    }

    //public getWinAnimation(): gsap.core.Timeline {
    //    return gsap.timeline()
    //        .add(() => {
    //            this.xwaysCounter!.position.set(-24, -64);
    //            this.removeChild(this.xwaysCounter!);
    //            this.addChild(this.xwaysCounter!)
    //        })
    //        .add(super.getWinAnimation())
    //        .add(() => {
    //            this.xwaysCounter!.position.set(-55, -55);
    //            this.removeChild(this.xwaysCounter!);
    //            this.addChildAt(this.xwaysCounter!, 1)
    //        });
    //}
}
